<div class="container">
  <ng-container *ngIf="myreturns$ | async; else noBrands">
    <div>
      <button
        style="margin: 2px; float:right"
        class="btn btn-primary"
        (click)="openReturnConfirmDialog()"
        name="Submit Return"
        [disabled]="!changesDetected"
        *ngIf="!isCompleted"
      >
        Mark Complete
      </button>

      <button
        style="margin: 2px; float:right"
        class="btn btn-primary"
        (click)="openReturnSaveConfirmDialog()"
        name="Submit Return"
        [disabled]="!changesDetected"
        *ngIf="!isCompleted"
      >
        Save Work
      </button>

      <a
        mat-button
        class="btn btn-primary"
        *ngIf="isCompleted; else elseBlock"
        target="_blank"
        style="float:right; margin: 2px;"
        href="{{ shippingLabel }}"
      >
        Print Shipping Label</a
      >
      <ng-template #elseBlock>
        <button style="margin: 2px; float:right" class="btn btn-primary" [disabled]="true">
          Print Shipping Label
        </button>
      </ng-template>
    </div>
    <div
      *ngFor="
        let brand of myreturns$ | async | filterByBrand: brand.selectedBrand | searchList: searchTerm;
        let brandIndex = index
      "
    >
      <h1>{{ brand['brandName'] }}</h1>
      <div *ngFor="let module of brand['modules'] | searchList: searchTerm; let moduleIndex = index">
        <div class="row">
          <div class="col m9 s12 l12">
            <h2>{{ module.categoryName }} - {{ module.moduleName }}</h2>
          </div>
        </div>
        <!-- Data Table -->
        <div class="data-table mt-30">
          <div
            class="data-table-header mat-header-row collection__table-header-desktop"
            matSort
            (matSortChange)="sortData($event)"
          >
            <!--s2 s2 s2 s1 s2-->
            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="smallImageUrl">
              Image
            </span>

            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="styleName">
              Style Name
            </span>

            <span class="col s3 data-table-cell data-table-cell-show-small" mat-sort-header="colorDescription">
              Color
            </span>

            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="eyeSize">
              Size
            </span>

            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="upc">
              UPC
            </span>
            <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="return">
              Return
            </span>
          </div>
          <section class="data-table-tbody">
            <div
              class="row data-table-row"
              *ngFor="let frame of module['frames'] | searchList: searchTerm; let i = index"
            >
              <div class="col s2 data-table-cell product-item__image">
                <div class="data-table-data frame--image s12">
                  <img
                    [src]="frame['largeImageUrl']"
                    [alt]="frame['largeImageUrl']"
                    class="collection__frame-image"
                    onError="this.src='/assets/images/frame-default-sm.png'"
                  />
                </div>
                <div class="row hide-desktop">
                  <div class="col s12">
                    <div class="row">
                      <div class="col s12">
                        <button
                          class="accordion"
                          (click)="panelDisplay[i] = panelDisplay[i] === 'block' ? 'none' : 'block'"
                        >
                          <strong>Style Name</strong> {{ frame['styleName'] }}
                        </button>
                        <div class="panel" [ngStyle]="{ display: panelDisplay[i] }">
                          <div class="row">
                            <div class="col s12">
                              <div class="row">
                                <div class="col s4">
                                  <strong>Color</strong>
                                </div>
                                <div class="col s8">
                                  {{ frame['colorDescription'] }}
                                </div>
                              </div>
                              <div class="row">
                                <div class="col s4">
                                  <strong>Size</strong>
                                </div>
                                <div class="col s8">{{ frame['eyeSize'] }}-{{ frame['temple'] }}</div>
                              </div>
                              <div class="row">
                                <div class="col s4">
                                  <strong>UPC</strong>
                                </div>
                                <div class="col s8">
                                  {{ frame['upc'] }}
                                </div>
                              </div>
                              <div class="row">
                                <div class="col s4">
                                  <strong>Return</strong>
                                </div>
                                <div class="col s8">
                                  {{ frame.isReturned }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['styleName'] }}</span>
              </div>
              <div class="col s3 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['colorDescription'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['eyeSize'] }}-{{ frame['temple'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['upc'] }}</span>
              </div>
              <div class="col s1 data-table-cell">
                <mat-checkbox
                  class="data-table-data"
                  [ngModel]="frame.isReturned"
                  [checked]="frame.isReturned"
                  [disabled]="isCompleted"
                  (change)="valueChanged($event, frame)"
                  name="retCheckBox-{{ brandIndex }}{{ moduleIndex }}{{ i }}"
                ></mat-checkbox>
              </div>
            </div>
          </section>
        </div>
        <!-- END Data Table -->
      </div>
    </div>
  </ng-container>
</div>

<ng-template #noBrands>
  <!--   <div class="row">
    <div class="col s12">
      <mat-card class="mat-card--widget">
        <mat-card-content class="offers-list__empty">
          <div class="container text-center">
            <h3 class="h3">Your Refresh returns cart is empty.  Please check back during the next Refresh for the list of frames to be returned.</h3>
            <p>Please refer to the Refresh document (link if that is possible to the file in Resource titled Placeholder How To Refresh) in the Resource section of the Help Center for Refresh instructions.</p>
            <a routerLink="/" class="btn btn-link">Return to my catalog</a>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div> -->
</ng-template>
<div></div>
<!-- CanLeave Popup Dialog (based on MatDialog) -->
<ecp-can-leave [dontLeave]="changesDetected" [disableClose]="true" #canLeave>
  <div [class]="theme ? theme : 'one-portal'">
    <h2 mat-dialog-title><b>Unsaved changes</b></h2>

    <mat-dialog-content>
      You have unsaved changes which will be lost. Are you sure you wish to leave this page?
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button class="btn btn-primary" (click)="canLeave.close(false)" cdkFocusInitial>Stay on This Page</button>
      <button class="btn btn-secondary" (click)="canLeave.close(true)">Leave This Page</button>
    </mat-dialog-actions>
  </div>
</ecp-can-leave>
